import axios from 'axios'
import state from '../Auth/state'

const endPoint = '/events/slots'

export function getCloudProxy({ commit, store }, timezone) {

    return new Promise((resolve, reject) => {
        axios
            .get("/cloud-proxy")
            .then(response => {
                commit('setCloudProxy', response.data)
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getUpcomingEvents({ commit, store }, timezone) {

    return new Promise((resolve, reject) => {
        axios
            .post(endPoint + "/getupcomingevent", {
                "timezone": timezone
            })
            .then(response => {
                commit('setUpcomingEvents', response.data.data)
                resolve(true)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function setUpcomingEvent({ commit }, event) {
    commit('setUpcomingEvents', event)
}

export function setForceLeave({ commit }, forceleave) {
    commit('setForceLeave', forceleave)
}

export function setMeetingJoiningStatus({ commit }, status) {
    commit('setMeetingJoiningStatus', status)
}


export function setCurrentVideoSettings({ commit }, settings) {
    commit('setCurrentVideoSettings', settings)
}

export function getEventDetails({ commit, store }, slotId) {

    return new Promise((resolve, reject) => {
        axios
            .get(endPoint + "/fetchmeeting/" + slotId)
            .then(response => {
                commit('setEventDetails', response.data.data)
                resolve(response.data.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}


export function getLiveMembers({}, payload) {

    console.log("payload", payload)

    return new Promise((resolve, reject) => {
        axios
            .get(endPoint + "/get-live-members/" + payload.slotId)
            .then(response => {
                resolve(response.data.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}


export function getNumberOfParticipants({ commit }, slotId) {

    return new Promise((resolve, reject) => {
        axios
            .post("/insighttalks/listofparticipants", {
                roomId: slotId
            })
            .then(response => {
                // commit('setEventDetails', response.data.data)
                resolve(response.data.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// ListOfparticipants

export function joinUpcomingEvent({ commit, store }, props) {

    const data = {
        userId: props.userId,
        sessionId: props.sessionId,
        role_name: props.role_name
    }

    return new Promise((resolve, reject) => {
        axios
            .post(endPoint + "/" + props.slotId + "/sessions/joinsession", data)
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function leaveEvent({ commit, store }, props) {

    const data = {
        userId: props.userId,
        sessionId: props.sessionId,
        role_name: props.role_name
    }

    return new Promise((resolve, reject) => {
        axios
            .post(endPoint + "/" + props.slotId + "/sessions/leavesession", data)
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function conferenceRoomDetails({ state, commit }, props) {
    return new Promise((resolve, reject) => {
        axios
            .post(`/events/slots/conferenceroomdetails`, { coaching_track_id: props.coaching_track_id })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getConferenceNumbers({ state, commit }) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/dial-in-settings`)
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function resetStore({ commit, store }) {
    commit('resetStore')
}